import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3.6 20.4l8.371 -8.371m2.04 -2.04l6.389 -6.389","key":"svg-0"}],["path",{"d":"M6 8h2m0 0v2","key":"svg-1"}],["path",{"d":"M14 16h2","key":"svg-2"}],["path",{"d":"M7 3h12a2 2 0 0 1 2 2v12m-.5 3.5c-.362 .36 -.95 .5 -1.5 .5h-14a2 2 0 0 1 -2 -2v-14c0 -.541 .215 -1.033 .565 -1.393","key":"svg-3"}],["path",{"d":"M3 3l18 18","key":"svg-4"}]]

const IconExposureOff = createReactComponent('outline', 'exposure-off', 'ExposureOff', __iconNode);

export default IconExposureOff;